export const layoutClasses= [
    { default:'compact-wrapper' },
    { Horizontal:'horizontal-wrapper' },
];